module.exports = __webpack_public_path__ + "static/img/2-02.b25ce8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/2-02.png
// module id = 219
// module chunks = 0